export default __webpack_public_path__ + "static/media/seedx-hero-362x420.6d04ef36.svg";